/**
 * Name-only shim. Bid creation runs in the web app; the pane keeps the tool
 * names so `tool-activity.tsx` can label a thread that was started there.
 */
export const COMPLETE_BID_CREATION_TOOL_NAME = "complete_bid_creation";
export const REQUEST_BID_TEAM_TOOL_NAME = "request_bid_team";
